'use client'

import { Button, Cell, Dialog, Spacer, Text } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { clickEvent } from '@marketplace-web/catalog/catalog-page-data'
import { HelpCenterFaqEntryUrl } from '@marketplace-web/help-center/help-center-faq-entry-url-feature'
import {
  AccessChannel,
  FaqEntryType,
} from '@marketplace-web/help-center/help-center-faq-entry-url-data'

import { OUR_PLATFORM_URL } from '../../../../constants/routes'

type Props = {
  show: boolean
  onConfirmOrClose: () => void
}

const SearchResultsRankingModal = ({ show, onConfirmOrClose }: Props) => {
  const translate = useTranslate('catalog.search_results.ranking_modal')
  const { track } = useTracking()

  const handleSearchResultsLearnMoreClick = () => {
    track(clickEvent({ target: 'help_center_search_result' }))
  }

  const handleBumpsLearnMoreClick = () => {
    track(clickEvent({ target: 'push_up_learn_more' }))
  }

  const renderBody = () => (
    <Cell styling={Cell.Styling.Tight}>
      <Text as="h2" text={translate('subtitle')} type={Text.Type.Title} />
      <Spacer size={Spacer.Size.Medium} />
      <Text as="span" html text={translate('body.one')} type={Text.Type.Body} />
      <Spacer size={Spacer.Size.Medium} />
      <Text as="span" html text={translate('body.two')} type={Text.Type.Body} />
      <Spacer size={Spacer.Size.Medium} />
      <a
        href={OUR_PLATFORM_URL}
        onClick={handleSearchResultsLearnMoreClick}
        target="_blank"
        rel="noreferrer"
      >
        {translate('link')}
      </a>
      <Spacer size={Spacer.Size.X3Large} />
      <Text as="h2" text={translate('bumps.subtitle')} type={Text.Type.Title} />
      <Spacer size={Spacer.Size.Medium} />
      <Text as="span" html text={translate('bumps.body')} type={Text.Type.Body} />
      <Spacer size={Spacer.Size.Medium} />
      <HelpCenterFaqEntryUrl
        type={FaqEntryType.Bump}
        accessChannel={AccessChannel.ProductLink}
        render={url => (
          <a
            data-testid="bumps-faq-link"
            href={url}
            onClick={handleBumpsLearnMoreClick}
            target="_blank"
            rel="noreferrer"
          >
            {translate('bumps.link')}
          </a>
        )}
      />
      <Spacer size={Spacer.Size.X3Large} />
      <Button
        text={translate('actions.confirm')}
        styling={Button.Styling.Filled}
        size={Button.Size.Medium}
        onClick={onConfirmOrClose}
      />
      <Spacer size={Spacer.Size.Medium} />
    </Cell>
  )

  return (
    <Dialog
      enableCloseButton
      hasScrollableContent
      className="search-results-ranking-modal"
      body={renderBody()}
      defaultCallback={onConfirmOrClose}
      show={show}
      testId="search-results-ranking-modal"
      title={translate('title')}
    />
  )
}

export default SearchResultsRankingModal
